import styled from "@emotion/styled";
import InputBlurChange from "metabase/components/InputBlurChange";

export const ChartSettingInputBlurChange = styled(InputBlurChange)`
  display: block;
  width: 100%;
`;
